import React from 'react';
import moment from 'moment';
import { TBody, Tr, Td, Th } from 'components/UIKit/Table';
import { uniqueCases } from 'utils/transactions';
import VerticalTable from 'components/DetailsPanels/VerticalTable';

let TransactionInnerDetails = ({ tx, entities, groupedByRole }) => {
  return (
    <VerticalTable customDataTestID="table-transaction-details" >
      <TBody>
        <Tr><Th>Project</Th><Td>{tx.project_id}</Td></Tr>
        <Tr><Th>Type</Th><Td style={{textTransform: 'capitalize'}}>{tx.type}</Td></Tr>
        <Tr><Th>Status</Th><Td>{tx.state}</Td></Tr>
        { tx.type === 'upload' && <Tr><Th>Step</Th><Td>{tx.is_dry_run ? 'Validate' : 'Commit'}</Td></Tr> }
        <Tr><Th>User</Th><Td>{tx.submitter || '--'}</Td></Tr>
        <Tr><Th>Cases Affected</Th><Td>{uniqueCases(entities)}</Td></Tr>
        {tx.type === 'upload' && [
          <Tr key="one"><Th>Entities Created</Th><Td>{groupedByRole.create || 0}</Td></Tr>,
          <Tr key="two"><Th>Entities Updated</Th><Td>{groupedByRole.update || 0}</Td></Tr>
        ]}
        { tx.type === 'release' && (
          <Tr><Th>Entities Released</Th><Td>{groupedByRole.release || 0}</Td></Tr>
        )}
        <Tr><Th>Date Created</Th><Td>{moment(tx.created_datetime).format('ll')}</Td></Tr>
      </TBody>
    </VerticalTable>
  );
};

export default TransactionInnerDetails;
